module.exports = __webpack_public_path__ + "static/media/m_sf_10.e3e4ef40.png";